import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  claimsRecords: [],
  totalPages: 0,
  totalCount: 0,
  pageNo: 1,
  search: false,
};
export const ClaimsSlice = createSlice({
  name: "claims",
  initialState,
  reducers: {
    setClaimRecords: (state, action) => {
      state.claimsRecords = action.payload.data || [];
      state.totalPages = action.payload.totalPages || 0;
      state.totalCount = action.payload.totalCount || 0;
      state.pageNo = action.payload.pageNo || 1;
      state.search = action.payload.search ?? "";
    },
  },
});
export const { setClaimRecords } = ClaimsSlice.actions;
export default ClaimsSlice.reducer;
